import React from 'react'

const CodePreview = ({code, color = 'white', minHeight = '584px'}) => {
    return (
        <pre style={{
            fontFamily: '"Fira code", "Fira Mono", monospace',
            fontSize: '12px',
            outline: 0,
            minHeight: minHeight,
            maxWidth: '1040px',
            backgroundColor: '#272822',
            color: color,
            padding: '10px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all'
        }}>{code}</pre>
    )
}

export default CodePreview;